/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export class AzureTenantStore {
    public id: string;

    public name: string;

    public defaultDomain: string;

    constructor(id: string, data: Partial<Omit<AzureTenantStore, 'id'>>) {
        this.id = id;
        this.name = data.name;
        this.defaultDomain = data.defaultDomain;
    }
}
